import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { PMDialog } from "../../utils/PMDialog";
import "./offer-workspace.css";

const METHODS = [
  { value: "", labelKey: "offers.pricing.method_legacy" },
  { value: "markup", labelKey: "offers.pricing.method_markup" },
  { value: "target_margin", labelKey: "offers.pricing.method_target_margin" },
  { value: "fixed_sales", labelKey: "offers.pricing.method_fixed_sales" },
];

/**
 * Dialog-først CALC-001: velg påslag vs mål-DG vs fast salg.
 * Skriver til item.custom_fields (pricing_method / pricing_rate / price_status).
 */
export default function OfferPricingMethodDialog({
  open,
  onClose,
  item,
  onApply,
}) {
  const { t } = useTranslation();
  const fields = item?.custom_fields || {};
  const [method, setMethod] = useState(fields.pricing_method || "");
  const [ratePercent, setRatePercent] = useState(
    fields.pricing_rate != null && fields.pricing_rate !== ""
      ? String(Number(fields.pricing_rate) * 100)
      : "20"
  );
  const [priceStatus, setPriceStatus] = useState(fields.price_status || "estimated");

  useEffect(() => {
    if (!open) return;
    const next = item?.custom_fields || {};
    setMethod(next.pricing_method || "");
    setRatePercent(
      next.pricing_rate != null && next.pricing_rate !== ""
        ? String(Number(next.pricing_rate) * 100)
        : "20"
    );
    setPriceStatus(next.price_status || "estimated");
  }, [open, item]);

  const handleSave = () => {
    const custom_fields = { ...(item?.custom_fields || {}) };
    if (!method) {
      delete custom_fields.pricing_method;
      delete custom_fields.pricing_rate;
      delete custom_fields.price_status;
    } else {
      custom_fields.pricing_method = method;
      custom_fields.price_status = priceStatus;
      if (method === "markup" || method === "target_margin") {
        const pct = Number(String(ratePercent).replace(",", "."));
        custom_fields.pricing_rate = Number.isFinite(pct) ? String(pct / 100) : "0.2";
      } else {
        delete custom_fields.pricing_rate;
      }
    }
    onApply?.({ custom_fields });
    onClose?.();
  };

  return (
    <PMDialog
      open={open}
      onClose={onClose}
      size="md"
      title={t("offers.pricing.dialog_title")}
    >
      <div className="flex flex-col gap-3">
        <p className="text-sm text-slate-600">{t("offers.pricing.dialog_hint")}</p>
        <label className="text-sm">
          <span className="mb-1 block font-medium">{t("offers.pricing.method")}</span>
          <select
            className="offer-select"
            value={method}
            onChange={(e) => setMethod(e.target.value)}
          >
            {METHODS.map((opt) => (
              <option key={opt.value || "legacy"} value={opt.value}>
                {t(opt.labelKey)}
              </option>
            ))}
          </select>
        </label>
        {method === "markup" || method === "target_margin" ? (
          <label className="text-sm">
            <span className="mb-1 block font-medium">{t("offers.pricing.rate_percent")}</span>
            <input
              type="text"
              className="w-full rounded-md border border-slate-300 px-2 py-1.5 text-sm"
              value={ratePercent}
              onChange={(e) => setRatePercent(e.target.value)}
            />
          </label>
        ) : null}
        {method ? (
          <label className="text-sm">
            <span className="mb-1 block font-medium">{t("offers.pricing.price_status")}</span>
            <select
              className="offer-select"
              value={priceStatus}
              onChange={(e) => setPriceStatus(e.target.value)}
            >
              <option value="estimated">{t("offers.pricing.status_estimated")}</option>
              <option value="missing">{t("offers.pricing.status_missing")}</option>
              <option value="confirmed_zero">{t("offers.pricing.status_confirmed_zero")}</option>
            </select>
          </label>
        ) : null}
        <div className="flex justify-end gap-2 border-t border-slate-100 pt-3">
          <button
            type="button"
            className="rounded-md border border-slate-300 px-3 py-1.5 text-sm"
            onClick={onClose}
          >
            {t("offers.presentation.cancel")}
          </button>
          <button
            type="button"
            className="rounded-md bg-[#1463C7] px-3 py-1.5 text-sm font-semibold text-white"
            onClick={handleSave}
          >
            {t("offers.presentation.save")}
          </button>
        </div>
      </div>
    </PMDialog>
  );
}
